import { createContext, useState } from 'react';

export const HomeContext = createContext();

export const HomeProvider = ({ children }) => {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(false);   // ✅ new: loading state
  const [error, setError] = useState(null);        // ✅ new: error state

  return (
    <HomeContext.Provider value={{ homeData, setHomeData, loading, setLoading, error, setError }}>
      {children}
    </HomeContext.Provider>
  );
};
